/** @jsxImportSource @emotion/react */
import { Typography } from '@quickbit/qb-design-system';

export const WalletNotAvailable = () => {
  return (
    <div
      css={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="heading2">
        This feature has not been enabled by Quickbit.
      </Typography>
    </div>
  );
};
